<template>
<div>

    <div class="course-main">

        <div class="course-card">
            <div class="course-pic" id="web">
                <img src="../../assets/web.png" width="200">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b>Web Development</b><br>
                    <p>
                        Learn how to make insane websites 
                        and apply web-dev concepts.
                        <!-- <button class="preview-btn">Preview Course</button> -->
                    </p> 
                    
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="game">
                <img src="../../assets/p5.png" width="200">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b>Game Development </b><br>
                    <p>
                        Build games with p5.js and learn 2D visualization techniques.
                        <!-- <button class="preview-btn">Preview Course</button>    -->
                    </p>
                    
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="python">
                <img src="../../assets/python.png" width="200">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b>Python Programming</b><br>
                    <p>
                        Experience the power of python and enrich your fundamentals. 
                        <!-- <button class="preview-btn">Preview Course</button> -->
                    </p>
                    
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="cpp">
                <img src="../../assets/cplus2.png" width="200">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b>C++ Competitive Programming</b><br>
                    <p>
                        Dominate the genre of Competitive Programming with the power of C++.<br>
                        <!-- Dominate data analysis and data representation with spreadsheets.<br> -->
                        <!-- <button class="preview-btn" @click="this.$router.push('/Courses').catch(err => {console.log(err);console.clear();})">Preview Course</button> -->
                    </p>
                    
                </div>
            </div>
            
        </div>
        
    </div>  
    <button class="preview-btn" @click="gotocourse">More Courses ></button> 
</div> 
</template>



<script>
export default {
    name:'CoursesCards',
    methods:{
        gotocourse(){
            this.$router.push('/Courses').catch(err => {console.log(err);console.clear();})
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    }
}
</script>


<style scoped>
img{
     -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
}
    .course-main{
        margin-top: 2rem;
        display:grid;
        grid-template-columns:auto auto;
        justify-content: center;
    }   
    .course-card{
        width: 18rem;
        height: 20rem;
        margin: 0.5rem;
        background-color: white;
        /* border: 2px solid rgb(221, 219, 219); */
        border-radius: 0.3rem;
        box-shadow: 0 2px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

    .course-card:hover{
         box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }

    .course-pic{
       height: 60%;
       border: 2px solid rgb(238, 236, 236);
       border-radius: 0.3rem;
       display: flex;
       justify-content: center;
       align-items: center;
       

    }

    .course-bottom-text{
        height: 40%;
        padding: 0.5rem;
        color: #1c1b1b;
        font-family: 'Chelsea Market', sans-serif;
        font-size: 0.9em;
        font-weight: 400;
        text-align: center;
    }

    .preview-btn{
        width: 15rem;
        height: 3rem;
        margin-top:1rem ;
        border-radius: 0.1rem;
        border: 0;
        color: rgb(47, 22, 22);
        font-weight: 500;
        font-family: 'Josefin Sans', sans-serif;
        font-size: 1em;
        box-shadow: 0 2px 2px 0 rgb(160, 160, 160);
        background-color: #ffca0b;
        margin-bottom: 3rem;
    }
    .preview-btn:hover{
        background-color: #eeb12e;
    }

    @media screen and (max-width:768px){
        .course-main{
        margin-top: 2rem;
        display:grid;
        grid-template-columns:auto;
        justify-content: center;
    }   
    .course-card{
        width: 17rem;
        height: 19rem;
        margin: 0.5rem;
        border: 2px solid rgb(221, 219, 219);
        border-radius: 0.3rem;
        box-shadow: 0 2px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

    .course-card:hover{
         box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }

    .course-pic{
       height: 60%;
       border: 2px solid rgb(238, 236, 236);
       border-radius: 0.3rem;
    }

    .course-bottom-text{
        height: 40%;
        padding: 0.5rem;
        color: #1c1b1b;
        font-family: 'Chelsea Market', sans-serif;  
        font-size: 0.9em;
        font-weight: 400;
    }

    }
</style>